module.exports = __webpack_public_path__ + "img/logo-S.77e109e1.svg";